import { graphql } from '~/gql'

const UPDATE_VERSION_NAME_MUTATION = graphql(`
  mutation updateVerionName($id: ID!, $name: String!) {
    updateVersionName(id: $id, name: $name) {
      ...VersionFragment
    }
  }
`)

export default UPDATE_VERSION_NAME_MUTATION
